import { Component, Input } from '@angular/core';
import { Equipo } from '@domain/equipo';
import { EstatusRetosEquipo } from '@domain/estatus.reto.equipo';
import { Jugador } from '@domain/jugador';
import { EstatusRetoEnum } from '@domain/estatus.reto.enum';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';

@Component({
  selector: 'existe-ganador',
  templateUrl: 'existe-ganador.html'
})
export class ExisteGanadorComponent {

  @Input('equipo') equipo: Equipo;
  @Input('jugador') jugador: Jugador;
  @Input('estatus') estatus: EstatusRetosEquipo;
  @Input('show') show: boolean;
  @Input('tablero') tablero: Array<any>;

  ESTATUS_RETO_ENUM = EstatusRetoEnum;
  close: Observable<boolean>;
  private $close: Subject<boolean>;

  constructor() {
    this.$close = new Subject<boolean>();
    this.close = this.$close.asObservable();
  }

  cerrar() {
    this.show = false;
    this.$close.next(this.show);
  }

  miPosicion(): number {
    if(this.tablero[0] && this.tablero[0].equipo._id === this.equipo._id) {
        return 1;
    }
    if(this.tablero[1] && this.tablero[1].equipo._id === this.equipo._id) {
        return 2;
    }
    if(this.tablero[2] && this.tablero[2].equipo._id === this.equipo._id) {
        return 3;
    }

    return -1;
  }

}



// WEBPACK FOOTER //
// ./src/components/existe-ganador/existe-ganador.ts